const Carousel = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
    $el.parent().find('.slick-prev').on('click', () => $el.slick('slickPrev'))
    $el.parent().find('.slick-next').on('click', () => $el.slick('slickNext'))
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 1,
        variableWidth: false,
        arrows: false,
        dots: false,
        infinite: true,
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default Carousel;



// WEBPACK FOOTER //
// ./scripts/components/Carousel.js